// extracted by mini-css-extract-plugin
export default {"discount":"TableCoupon_discount__-X8yC"};